import { useQuery } from '@tanstack/react-query';
import { getFiles } from '../components/FileExplorer/services';
import { getFileExplorerQueryKey } from '../utils/fileExplorer';

interface UseFileExplorerParams {
  isRoot: boolean;
  categoryId?: number;
}

export function useFileExplorer({ isRoot, categoryId }: UseFileExplorerParams) {
  // If isRoot is true, we use a constant query key for the root folder
  // Otherwise, we use the categoryId as the query key
  // This allows us to fetch the root folder data or a specific category's data
  // based on the isRoot flag and categoryId provided.
  const queryKey = getFileExplorerQueryKey(categoryId);
  // The enabled flag determines whether the query should run.
  // If isRoot is true, we fetch the root folder data.
  // If categoryId is provided, we fetch the specific category's data.
  const enabled = isRoot || !!categoryId;

  const {
    data: fileExplorerContent,
    isLoading: isFileExplorerLoading, isError: isFileExplorerError,
  } = useQuery({
    queryKey: [queryKey],
    queryFn: () => getFiles({ id: categoryId }),
    enabled,
  });

  return {
    isFileExplorerLoading,
    isFileExplorerError,
    files: fileExplorerContent?.data.files,
    folders: fileExplorerContent?.data.folders,
    isFetchEnabled: enabled,
  };
}
